import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import ClientShipCard from "./ClientShipCard";
import MMPLShipCard from "./MMPLShipCard";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getClientShipCount,
  getClientShipDetails,
} from "../Actions/ClientDashboardAPI";
import {
  getContractClientName,
  getContractCount,
  getContractDeatil,
  getContractHistory,
  getContractSearchlist,
  getContractShipList,
  postContractDeatil,
  getClientIMONO,
  getContractTypeOptions,
  getBillingTypeOptions,
  getPlanTypeOptions,
  getContractStatusOptions,
  getShipOptions,
} from "../Actions/ContractMgmtAPI";
import { postContractAttachment } from "../Actions/CommonAPI";
import { getshipNameList } from "../Actions/UserManageAPI";
import axios from "axios";
import API, { discountTypes } from "../helpers/api";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { deleteAttachmentInBucket } from "../Actions/CommonAPI";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

const SearchItem = {
  contractNumber: "",
  ShipName: "",
  ImoNo: "",
  clientName: "",
  startdate: "",
  expiryDate: "",
  minyear: "",
  maxyear: "",
  contractStatusId: 7,
  PageSize: 25,
  PageNumber: 1,
  overDue: false,
  dueIn30Days: false,
};

var fileDatas = [];

class AddContract extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDate: "",
      TotalContracts: 100,
      OverDue: 90,
      DueIn30Days: 100,
      toDate: "",
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      filterTitle: "All Ships",
      shipName: "",
      searchDate: {
        shipId: "",
        contractNumber: "",
        imoNo: "",
        clientName: "",
        status: 0,
        attachmentName: "",
        attachmentGuid: "",
        contractType: 0,
        planType: 0,
        billingPeriod: 0,
        startDate: "",
        endDate: "",
        comments: "",
        amount: 0,
        createdBy: currentuser.name,
        isExtraCharge: false,
        isExtraChargeApplicable: true,
        extraCharge: 0,
        isDiscountApplicable: false,
        discountValue: "",
        discountType: "",
        isSurchargeIfz: false,
        surchargeIfz: "",
        surchargeIfztype: "",
      },
      discountTypes: [],
      isIfz: false,
    };
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
  }

  componentDidMount() {
    const { dispatch, match, contractClientName } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Contract Management" });
    dispatch(getShipOptions());
    this.getDiscountTypes();
    // if (match.params.id) {
    //     dispatch(getContractCount(match.params.id));
    // }
    dispatch(getContractStatusOptions());
    dispatch(getContractTypeOptions());
    dispatch(getBillingTypeOptions());
    // dispatch(getshipNameList());
    console.log(this.state.searchDate);
  }

  getDiscountTypes = () => {
    let url = `${API.discountTypes}`;
    axios
      .get(url)
      .then((response) => {
        this.setState({ discountTypes: response.data });
        this.setState((prev) => ({
          searchDate: {
            ...prev.searchDate,
            discountType: "Percentage",
            surchargeIfztype: "Percentage",
          },
        }));
      })
      .catch((error) => {
        console.log("Error fetching discount types:", error);
      });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, contractAttachment, ClientIMONO } = nextProps;
    if (contractAttachment) {
      prevState.searchDate.attachmentName = contractAttachment.FileName;
      prevState.searchDate.attachmentGuid = contractAttachment.Guid;
      dispatch({ type: "postContractAttachmentUploadSuccess", data: null });
    }
    if (ClientIMONO) {
      prevState.searchDate.clientName = ClientIMONO.clientName;
      prevState.searchDate.imoNo = ClientIMONO.imo;
    }
  }

  getShipDetails(action) {
    if (action === "noAction") {
      this.state.filterTitle = "All Ships";
      this.state.searchDate.serviceStatus = "noAction";
    } else if (action === "expired") {
      this.state.filterTitle = "Expired Ships";
      this.state.searchDate.serviceStatus = "expired";
    } else {
      this.state.filterTitle = "Expiring Ships";
      this.state.searchDate.serviceStatus = "expiring";
    }
    this.setState({ showClientDetails: false, filterclientDetails: false });
    // this.SearchMDData(1);
  }

  getClientDetails() {
    this.setState({ showClientDetails: true, filterShiplist: false });
  }

  addContract() {
    const { dispatch, t } = this.props;
    const { searchDate } = this.state;
    if (
      searchDate.shipId > 0 &&
      searchDate.startDate !== "" &&
      searchDate.endDate !== "" /* && searchDate.status > 0 */ &&
      searchDate.contractType > 0 &&
      searchDate.planType > 0 &&
      searchDate.billingPeriod > 0 &&
      searchDate.contractNumber !== "" &&
      (!searchDate.isExtraCharge ||
        (searchDate.extraCharge !== 0 && searchDate.extraCharge !== "")) &&
      (!searchDate.isDiscountApplicable ||
        (searchDate.discountValue !== 0 &&
          searchDate.discountValue !== "" &&
          searchDate.discountValue !== null)) &&
      (!searchDate.isSurchargeIfz ||
        !this.state.isIfz ||
        (searchDate.surchargeIfz !== 0 &&
          searchDate.surchargeIfz !== "" &&
          searchDate.surchargeIfz !== null))
    ) {
      let url = `${API.MMPLPostContractDetails}`;
      let data = {
        ...this.state.searchDate,
        extraCharge: this.state.searchDate.isExtraCharge
          ? this.state.searchDate.extraCharge
          : 0,
        discountType: this.state.searchDate.isDiscountApplicable
          ? this.state.searchDate.discountType
          : null,
        discountValue: this.state.searchDate.isDiscountApplicable
          ? this.state.searchDate.discountValue
          : null,
        isSurchargeIfz:
          this.state.searchDate.isSurchargeIfz && this.state.isIfz
            ? this.state.searchDate.isSurchargeIfz
            : false,
        surchargeIfztype:
          this.state.searchDate.isSurchargeIfz && this.state.isIfz
            ? this.state.searchDate.surchargeIfztype
            : null,
        surchargeIfz:
          this.state.searchDate.isSurchargeIfz && this.state.isIfz
            ? parseInt(this.state.searchDate.surchargeIfz)
            : null,
      };
      axios
        .post(url, data)
        .then((response) => {
          if (response.data == true) {
            if (fileDatas.length > 0) {
              this.props.dispatch(deleteAttachmentInBucket(fileDatas));
              fileDatas = [];
            }

            dispatch(getContractSearchlist(SearchItem));
            this.cancel();
            toast.success(`${t("CommonText.CommonAdd")}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });

            dispatch({
              type: "PostContractDetailSuccess",
              data: response.data,
            });
          } else {
            swal(
              "Information!",
              "Not able to create contract for this ship!",
              "info"
            );
          }
        })
        .catch((error) => {
          dispatch({
            type: "PostContractDetailFailure",
            error: "ERROR",
          });
        });
    } else {
      swal(
        "Error!",
        `${t("ContractManagementContent.MandatoryWarningMsg")}`,
        "warning"
      );
    }
  }

  handleFromDateChange(date) {
    this.state.searchDate.startDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }

  handleToDateChange(date) {
    this.state.searchDate.endDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleRadioButtonChanges(e, id) {
    // let nodeName = e.target.name;
    this.state.searchDate["status"] = parseInt(e);
    this.setState({});
  }

  handleInputChange(e, value, name) {
    const { dispatch } = this.props;
    let nodeName = e.target.name;
    if (name == "shipId") {
      if (value?.lookUpId) {
        let url = `${API.VerifyShipContractField}${value?.lookUpId}`;
        axios
          .get(url)
          .then((response) => {
            if (response.data == true) {
              dispatch(getClientIMONO(value?.lookUpName));
              this.state.searchDate[name] = value?.lookUpId;
              this.state.shipName = value;
            } else {
              this.state.searchDate[name] = 0;
              this.state.shipName = "";
              this.setState({});
              swal(
                "Information!",
                "Not able to create contract for this ship!",
                "info"
              );
            }
          })
          .catch((error) => {});
      }
    } else if (nodeName === "planType" || nodeName === "billingPeriod") {
      this.state.searchDate[nodeName] = parseInt(e.target.value);
    } else if (
      nodeName === "contractType" ||
      nodeName === "planType" ||
      nodeName === "billingPeriod"
    ) {
      if (nodeName === "contractType") {
        const selectedName = e.target.options[e.target.selectedIndex].text;
        this.state.isIfz = selectedName === "IFZ";
      }
      this.state.searchDate[nodeName] = parseInt(e.target.value);
    } else if (nodeName === "discountType") {
      if (e.target.value == "Percentage") {
        if (this.state.searchDate.discountValue > 100) {
          this.state.searchDate.discountValue = "";
        }
      }
      this.state.searchDate[nodeName] = e.target.value;
    } else if (nodeName === "surchargeIfztype") {
      if (e.target.value == "Percentage") {
        if (this.state.searchDate.surchargeIfz > 100) {
          this.state.searchDate.surchargeIfz = "";
        }
      }
      this.state.searchDate[nodeName] = e.target.value;
    } else {
      this.state.searchDate[nodeName] = e.target.value;
    }
    if (nodeName == "contractType") {
      this.state.searchDate["planType"] = 0;
      dispatch(getPlanTypeOptions(e.target.value));
    }
    if (nodeName === "attachmentName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.state.searchDate.attachmentName = e.target.files[0].name;
        dispatch(postContractAttachment(e.target.files[0]));
      } else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning"
        );
        return;
      }
    }
    this.setState({});
  }

  ClearInput() {
    //this.props.dispatch(deleteAttachmentInBucket(this.state.searchDate.attachmentGuid,this.state.searchDate.attachmentName));
    let obj = {
      filename: this.state.searchDate.attachmentName,
      guid: this.state.searchDate.attachmentGuid,
    };
    fileDatas.push(obj);
    this.state.searchDate.attachmentName = "";
    this.state.searchDate.attachmentGuid = "";
    this.setState({});
  }

  cancel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowContractDetailsPane", data: false });
    this.props.history.push("/Home/Contracts");
  };

  render() {
    const { showContractDetailsPane, shipNameList, t } = this.props;
    return (
      <div className="full-height pt-3">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header mb-0"
                style={{ backgroundColor: "white", border: "0px" }}
              >
                <div className="card-body">
                  <h5 className="card-title m-2" style={{ color: "092a51" }}>
                    {t("ContractManagementContent.AddContract")}
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row">
                  <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }
                  >
                    <label className="form-label required">
                      {t("content.Ship")}
                    </label>
                    <br></br>
                    <Autocomplete
                      style={{ marginTop: "-12px" }}
                      name="shipId"
                      noOptionsText={`${t("CommonText.NoOption")}`}
                      size={"small"}
                      value={this.state.shipName}
                      onChange={(e, value) =>
                        this.handleInputChange(e, value, "shipId")
                      }
                      getOptionLabel={(item) => item.lookUpName || ""}
                      getItemValue={(item) => item.lookUpId}
                      options={
                        // this.props.shipListData ?? []
                        [
                          ...new Map(
                            (this.props.shipListData ?? []).map((item) => [
                              item.lookUpName,
                              item,
                            ])
                          ).values(),
                        ]
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={t(
                            "ContractManagementContent.SelectShip"
                          )}
                          margin="normal"
                        />
                      )}
                    />
                    {/* <select
                      className="form-control"
                      name="shipName"
                      value={this.state.searchDate.shipName}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">{t("ContractManagementContent.SelectShip")}</option>
                      {shipNameList &&
                        shipNameList.map((ships) => (
                          <option value={ships}>{ships}</option>
                        ))}
                    </select> */}
                  </div>
                  {/* <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }
                  >
                    <label className="form-label">{t("ShipManagementContent.contractNumber")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="contractNumber"
                      placeholder={t("ShipManagementContent.contractNumber")}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchDate.contractNumber}
                    ></input>
                  </div> */}
                  <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }
                  >
                    <label className="form-label">
                      {t("ContractManagementContent.IMONumber")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="imoNo"
                      placeholder={t("ContractManagementContent.IMONumber")}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchDate.imoNo}
                      readOnly
                    ></input>
                  </div>
                  <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }
                  >
                    <label className="form-label">
                      {t("ContractManagementContent.ClientName")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="clientName"
                      placeholder={t("ContractManagementContent.ClientName")}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchDate.clientName}
                      readOnly
                    ></input>
                  </div>
                  <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }
                  >
                    <label className="form-label required">
                      {t("ContractContent.ContractNumber")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="contractNumber"
                      placeholder={t("ContractContent.ContractNumber")}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchDate.contractNumber}
                    ></input>
                  </div>
                  {/* <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 wd"
                    }
                  >
                    <label className="form-label required">{t("EquipmentServiceTypes.Status")}</label>
                    <br></br>
                    <div
                      className={showContractDetailsPane ? "row" : "row pl-3"}
                    >
                       {this.props.contractStatus?.map((item, ind) => (
                        item.lookUpName &&
                        <div className={ showContractDetailsPane ? "col-sm-6 clsm-9" : "mt-2 mr-5"}>
                        <input
                          type="radio"
                          name={item.lookUpName}
                          checked={
                            this.state.searchDate.status === item.lookUpId
                          }
                          onChange={this.handleRadioButtonChanges.bind(this, item.lookUpId)}
                        ></input>
                        <span className="ml-1 text-capitalize">{item.lookUpName}</span>
                      </div>
                       ))}
                      {/* <div
                        className={
                          showContractDetailsPane
                            ? "col-sm-4 clsm-3"
                            : " mt-2 mr-5"
                        }
                      >
                        <input
                          type="radio"
                          name="active"
                          checked={
                            this.state.searchDate.contractStatus === "active"
                          }
                          onChange={this.handleRadioButtonChanges.bind(this)}
                        ></input>
                        <span className="ml-1">{t("ShipManagementContent.Active")}</span>
                      </div>
                      <div
                        className={
                          showContractDetailsPane
                            ? "col-sm-4 clsm-3"
                            : " mt-2 mr-5"
                        }
                      >
                        <input
                          type="radio"
                          name="pending"
                          checked={
                            this.state.searchDate.contractStatus === "pending"
                          }
                          onChange={this.handleRadioButtonChanges.bind(this)}
                        ></input>
                        <span className="ml-1">{t("ShipManagementContent.Pending")}</span>
                      </div>
                      <div
                        className={
                          showContractDetailsPane ? "col-sm-6 clsm-9" : " mt-2 "
                        }
                      >
                        <input
                          type="radio"
                          name="terminated"
                          checked={
                            this.state.searchDate.contractStatus ===
                            "terminated"
                          }
                          onChange={this.handleRadioButtonChanges.bind(this)}
                        ></input>
                        <span className="ml-1">{t("ShipManagementContent.Terminated")}</span>
                      </div> */}
                  {/* </div>
                  </div> */}

                  <div
                    className={
                      showContractDetailsPane
                        ? "col-lg-12  col-sm-12 col-xs-12"
                        : "col-lg-4  col-sm-12 col-xs-12"
                    }
                  >
                    <div className="row">
                      <div
                        className={
                          showContractDetailsPane ? "col-lg-6" : "col-lg-6"
                        }
                      >
                        <label className="form-label required">
                          {t("ContractManagementContent.StartDate")}
                        </label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.searchDate.startDate}
                            className="form-control date-picker"
                            placeholder={t(
                              "ContractManagementContent.StartDate"
                            )}
                            name="fromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                            maxDate={this.state.SelectedToDate}
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          showContractDetailsPane ? "col-lg-6" : "col-lg-6"
                        }
                      >
                        <label className="form-label required">
                          {t("ContractManagementContent.ExpiryDate")}
                        </label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.searchDate.endDate}
                            type="text"
                            placeholder={t(
                              "ContractManagementContent.ExpiryDate"
                            )}
                            className="form-control date-picker"
                            name="toDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                            minDate={this.state.SelectedFromDate}
                          />
                          <div className="input-group-btn calendar-icon">
                            <button
                              className="btn btn-default"
                              onClick={this.openToDatePicker}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }
                  >
                    <label className="form-label required">
                      {t("ShipEquipmentStatusScreen.ContractType")}
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="contractType"
                      id="contractType"
                      value={this.state.searchDate.contractType}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectContractType")}
                      </option>
                      {this.props.ContractType?.map((item) => (
                        <option value={item.lookUpId}>{item.lookUpName}</option>
                      ))}
                    </select>
                  </div>
                  <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }
                  >
                    <label className="form-label required">
                      {t("ShipEquipmentStatusScreen.PlanType")}
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="planType"
                      id="planType"
                      value={this.state.searchDate.planType}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectPlanType")}
                      </option>
                      {/* <option value="1">BASIC</option>
                      <option value="2">STD</option>
                      <option value="3">PREMIUM</option> */}
                      {this.props.PlanType?.map((item) => (
                        <option value={item.lookUpId}>{item.lookUpName}</option>
                      ))}
                    </select>
                  </div>
                  <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }
                  >
                    <label className="form-label required">
                      {t("ContractContent.BillingPeriod")}
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="billingPeriod"
                      id="billingPeriod"
                      value={this.state.searchDate.billingPeriod}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">
                        {t("ContractContent.SelectBillingPeriod")}
                      </option>
                      {/* <option value="1">Quarterly</option>
                      <option value="2">Half-yearly</option>
                      <option value="3">Yearly</option> */}
                      {this.props.BillingType?.map((item) => (
                        <option value={item.lookUpId}>{item.lookUpName}</option>
                      ))}
                    </select>
                  </div>
                  <div className={"col-lg-4"}>
                    <label className="form-label">
                      {t("ShipEquipmentStatusScreen.ContractAttachment")}
                    </label>
                    <br></br>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          {t("CommonText.BrowseFile")}
                          <input
                            type="file"
                            id="files"
                            name="attachmentName"
                            style={{ marginRight: 40 }}
                            onChange={(e) => this.handleInputChange(e)}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder={t("CommonText.Nofilechoosen")}
                        value={this.state.searchDate.attachmentName}
                      />
                      {this.state.searchDate.attachmentName ? (
                        <div
                          class="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            class="fa fa-times input-group-text padding-top-9px"
                            aria-hidden="true"
                            onClick={() => this.ClearInput()}
                          ></i>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {/* <div
                                        className={
                                            ` ${showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "}`
                                        }
                                    >
                                        <label className="form-label v-none">
                                            {t("ShipDetailsScreen.IsAdditionApplicable")}
                                        </label>
                                        <br></br>
                                        <div className="d-flex align-items-center">
                                            <input type="checkbox" className="checkbox-style" checked={this.state.searchDate.isExtraCharge} onChange={(event) => this.setState({
                                                searchDate: {
                                                    ...this.state.searchDate,
                                                    isExtraCharge: event.target.checked
                                                }
                                            })} />
                                            <label className="form-label ml-2">
                                                {t("ShipDetailsScreen.IsAdditionApplicable")}
                                            </label>
                                        </div>

                                    </div> */}
                  {/* {this.state.searchDate.isExtraCharge &&
                                        <div className={`${showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "}`}
                                        >
                                            <label className="form-label required">{t("ShipDetailsScreen.AdditionalCharge")}</label>
                                            <br></br>
                                            <div className="input-group">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    name="extraCharge"
                                                    placeholder={t("ShipDetailsScreen.AdditionalCharge")}
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    value={this.state.searchDate.extraCharge}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">USD</span>
                                                </div>
                                            </div>
                                        </div>
                                    } */}
                  {/* <div className={
                                        showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                                    }>
                                        <label className="form-label">{t("ContractContent.SumCollected")}</label>
                                        <br></br>
                                        <div className="input-group">
                                            <input
                                                className="form-control"
                                                type="number"
                                                name="amount"
                                                placeholder={t("ContractContent.SumCollected")}
                                                onChange={(e) => this.handleInputChange(e)}
                                                value={this.state.searchDate.amount}
                                            ></input>
                                            <div className="input-group-append">
                                                <span className="input-group-text">USD</span>
                                            </div>
                                        </div>
                                    </div> */}
                </div>
                <div className="row">
                  <div
                    className={` ${
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }`}
                  >
                    <div className="d-flex align-items-center mt-0 mt-lg-0 mb-1">
                      <input
                        type="checkbox"
                        className="checkbox-style"
                        checked={this.state.searchDate.isExtraCharge}
                        onChange={(event) =>
                          this.setState({
                            searchDate: {
                              ...this.state.searchDate,
                              isExtraCharge: event.target.checked,
                            },
                          })
                        }
                      />
                      <label
                        className="form-label ml-2"
                        style={{
                          flexShrink: 1,
                          minWidth: 0,
                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                          wordBreak: "break-all",
                        }}
                      >
                        {t("ShipDetailsScreen.IsAdditionApplicable")}
                      </label>
                      {this.state.searchDate.isExtraCharge && (
                        <div
                          className="input-group ml-2 w-auto"
                          style={{
                            minWidth: "145px",
                            flex: "1 1 auto",
                          }}
                        >
                          <input
                            className="form-control"
                            type="number"
                            name="extraCharge"
                            placeholder={t(
                              "ShipDetailsScreen.AdditionalCharge"
                            )}
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchDate.extraCharge}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">USD</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className={` ${
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }`}
                  >
                    <div className="d-flex align-items-center mt-0 mb-1">
                      <input
                        type="checkbox"
                        className="checkbox-style"
                        checked={this.state.searchDate.isDiscountApplicable}
                        onChange={(event) =>
                          this.setState({
                            searchDate: {
                              ...this.state.searchDate,
                              isDiscountApplicable: event.target.checked,
                            },
                          })
                        }
                      />
                      <label
                        className="form-label ml-2"
                        style={{
                          flexShrink: 1,
                          minWidth: 0,
                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                          wordBreak: "break-all",
                        }}
                      >
                        {/* Is Discount Applicable */}
                        {t("ShipDetailsScreen.isDiscountApplicable")}
                      </label>
                      {this.state.searchDate.isDiscountApplicable && (
                        <div
                          className="input-group w-auto ml-2"
                          style={{
                            minWidth: "145px",
                            flex: "1 1 auto",
                          }}
                        >
                          <input
                            className="form-control"
                            type="number"
                            name="discountAmount"
                            // placeholder={"Discount"}
                            placeholder={t("ShipDetailsScreen.Discount")}
                            // onChange={(e) => this.handleInputChange(e)}
                            onChange={(e) => {
                              const value = e.target.value;
                              const discountType =
                                this.state.searchDate.discountType;
                              if (value.trim() !== "") {
                                const isValidPercentage =
                                  /^(100(\.0{1,2})?|([1-9]?\d)(\.\d{1,2})?)$/.test(
                                    value
                                  ) && !/^100\.$/.test(value);
                                // const isValidPercentage = /^(100(\.00?)?|(\d{1,2})(\.\d{1,2})?)$/.test(value);
                                // const isValidPercentage = /^(100|[1-9]?[0-9])?$/.test(value);

                                if (
                                  discountType === "Percentage" &&
                                  !isValidPercentage
                                )
                                  return;

                                this.handleInputChange({
                                  target: {
                                    name: "discountValue",
                                    value,
                                  },
                                });
                              } else {
                                this.handleInputChange({
                                  target: {
                                    name: "discountValue",
                                    value,
                                  },
                                });
                              }
                            }}
                            value={this.state.searchDate.discountValue}
                          />
                          <div className="input-group-append">
                            <select
                              className="form-select input-group-text"
                              value={this.state.searchDate.discountType}
                              name="discountType"
                              onChange={(e) => this.handleInputChange(e)}
                            >
                              {this.state.discountTypes.map((type) => (
                                <option key={type} value={type}>
                                  {type == "Percentage" ? "%" : "USD"}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {this.state.isIfz && (
                    <div
                      className={` ${
                        showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                      }`}
                    >
                      {/* <label className="form-label v-none">
                                            Is Discount Applicable
                                        </label> */}
                      {/* <br></br> */}
                      <div className="d-flex align-items-center mt-0 mb-1">
                        <input
                          type="checkbox"
                          className="checkbox-style"
                          checked={this.state.searchDate.isSurchargeIfz}
                          onChange={(event) =>
                            this.setState({
                              searchDate: {
                                ...this.state.searchDate,
                                isSurchargeIfz: event.target.checked,
                              },
                            })
                          }
                        />
                        <label
                          className="form-label ml-2"
                          style={{
                            flexShrink: 1,
                            minWidth: 0,
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                            wordBreak: "break-all",
                          }}
                        >
                          Is Surcharge Applicable for IFZ
                        </label>
                        {this.state.searchDate.isSurchargeIfz &&
                          this.state.isIfz && (
                            <div
                              className="input-group w-auto ml-2"
                              style={{
                                minWidth: "145px",
                                flex: "1 1 auto",
                              }}
                            >
                              <input
                                className="form-control"
                                type="number"
                                name="discountAmount"
                                placeholder={"Surcharge"}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const discountType =
                                    this.state.searchDate.surchargeIfztype;
                                  if (value.trim() !== "") {
                                    const isValidPercentage =
                                      /^(100(\.0{1,2})?|([1-9]?\d)(\.\d{1,2})?)$/.test(
                                        value
                                      ) && !/^100\.$/.test(value);

                                    if (
                                      discountType === "Percentage" &&
                                      !isValidPercentage
                                    )
                                      return;

                                    this.handleInputChange({
                                      target: {
                                        name: "surchargeIfz",
                                        value,
                                      },
                                    });
                                  } else {
                                    this.handleInputChange({
                                      target: {
                                        name: "surchargeIfz",
                                        value,
                                      },
                                    });
                                  }
                                }}
                                value={this.state.searchDate.surchargeIfz}
                              />
                              <div className="input-group-append">
                                <select
                                  className="form-select input-group-text"
                                  value={this.state.searchDate.surchargeIfztype}
                                  name="surchargeIfztype"
                                  onChange={(e) => this.handleInputChange(e)}
                                >
                                  {this.state.discountTypes.map((type) => (
                                    <option key={type} value={type}>
                                      {type == "Percentage" ? "%" : "USD"}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                  {!this.state.isIfz && (
                    <div
                      className={`v-none ${
                        showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                      }`}
                    ></div>
                  )}

                  <div
                    className={`${
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    } ${this.state.isIfz ? "d-block" : "d-block"}`}
                  >
                    <label className="form-label">
                      {t("ContractContent.SumCollected")}
                    </label>
                    <br></br>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type="number"
                        name="amount"
                        placeholder={t("ContractContent.SumCollected")}
                        onChange={(e) => this.handleInputChange(e)}
                        value={this.state.searchDate.amount}
                      ></input>
                      <div className="input-group-append">
                        <span className="input-group-text">USD</span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }
                  >
                    <label className="form-label">
                      {t("ShipDetailsScreen.Comments")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="comments"
                      placeholder={t("ShipDetailsScreen.Comments")}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchDate.comments}
                    ></input>
                  </div>
                  <div
                    className={` ${
                      showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        className="checkbox-style"
                        checked={this.state.searchDate.isExtraChargeApplicable}
                        onChange={(event) =>
                          this.setState({
                            searchDate: {
                              ...this.state.searchDate,
                              isExtraChargeApplicable: event.target.checked,
                            },
                          })
                        }
                      />
                      <label className="form-label ml-2">
                        Is Extra Charges Applicable
                      </label>
                    </div>
                  </div>
                  {/* {!this.state.isIfz && (
                    <div
                      className={
                        showContractDetailsPane
                          ? "col-lg-6 d-none d-lg-block"
                          : "col-lg-4 d-none d-lg-block"
                      }
                    >
                      <label className="form-label">
                        {t("ContractContent.SumCollected")}
                      </label>
                      <br></br>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type="number"
                          name="amount"
                          placeholder={t("ContractContent.SumCollected")}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.searchDate.amount}
                        ></input>
                        <div className="input-group-append">
                          <span className="input-group-text">USD</span>
                        </div>
                      </div>
                    </div>
                  )} */}
                </div>
                <div className="row">
                  {/* {!this.state.searchDate.isExtraCharge &&
                    this.state.searchDate.isDiscountApplicable && (
                      <div
                        className={`v-none ${
                          showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                        }`}
                      ></div>
                    )} */}
                  {/* {!this.state.searchDate.isDiscountApplicable &&
                    !this.state.searchDate.isExtraCharge &&
                    this.state.searchDate.isSurchargeIfz &&
                    this.state.isIfz && (
                      <>
                        <div
                          className={`v-none ${
                            showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                          }`}
                        ></div>
                        <div
                          className={`v-none ${
                            showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                          }`}
                        ></div>
                      </>
                    )} */}

                  {/* {this.state.searchDate.isExtraCharge && (
                    <div
                      className={`${
                        showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                      }`}
                    >
                      <label className="form-label required">
                        {t("ShipDetailsScreen.AdditionalCharge")}
                      </label>
                      <br></br>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type="number"
                          name="extraCharge"
                          placeholder={t("ShipDetailsScreen.AdditionalCharge")}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.searchDate.extraCharge}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">USD</span>
                        </div>
                      </div>
                    </div>
                  )} */}
                  {/* {!this.state.searchDate.isDiscountApplicable &&
                    this.state.searchDate.isExtraCharge &&
                    this.state.searchDate.isSurchargeIfz &&
                    this.state.isIfz && (
                      <>
                        <div
                          className={`v-none ${
                            showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                          }`}
                        ></div>
                      </>
                    )} */}

                  {/* {this.state.searchDate.isDiscountApplicable && (
                    <div
                      className={`${
                        showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                      }`}
                    >
                      <label className="form-label required">
                        {t("ShipDetailsScreen.Discount")}
                      </label>
                      <br></br>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type="number"
                          name="discountAmount"
                          // placeholder={"Discount"}
                          placeholder={t("ShipDetailsScreen.Discount")}
                          // onChange={(e) => this.handleInputChange(e)}
                          onChange={(e) => {
                            const value = e.target.value;
                            const discountType =
                              this.state.searchDate.discountType;
                            if (value.trim() !== "") {
                              const isValidPercentage =
                                /^(100(\.0{1,2})?|([1-9]?\d)(\.\d{1,2})?)$/.test(
                                  value
                                ) && !/^100\.$/.test(value);
                              // const isValidPercentage = /^(100(\.00?)?|(\d{1,2})(\.\d{1,2})?)$/.test(value);
                              // const isValidPercentage = /^(100|[1-9]?[0-9])?$/.test(value);

                              if (
                                discountType === "Percentage" &&
                                !isValidPercentage
                              )
                                return;

                              this.handleInputChange({
                                target: {
                                  name: "discountValue",
                                  value,
                                },
                              });
                            } else {
                              this.handleInputChange({
                                target: {
                                  name: "discountValue",
                                  value,
                                },
                              });
                            }
                          }}
                          value={this.state.searchDate.discountValue}
                        />
                        <div className="input-group-append">
                          <select
                            className="form-select input-group-text"
                            value={this.state.searchDate.discountType}
                            name="discountType"
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            {this.state.discountTypes.map((type) => (
                              <option key={type} value={type}>
                                {type == "Percentage" ? "%" : "USD"}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )} */}
                  {/* Surcharge */}

                  {/* {this.state.searchDate.isSurchargeIfz && this.state.isIfz && (
                    <div
                      className={`${
                        showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "
                      }`}
                    >
                      <label className="form-label required">Surcharge</label>
                      <br></br>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type="number"
                          name="discountAmount"
                          placeholder={"Surcharge"}
                          onChange={(e) => {
                            const value = e.target.value;
                            const discountType =
                              this.state.searchDate.surchargeIfztype;
                            if (value.trim() !== "") {
                              const isValidPercentage =
                                /^(100(\.0{1,2})?|([1-9]?\d)(\.\d{1,2})?)$/.test(
                                  value
                                ) && !/^100\.$/.test(value);

                              if (
                                discountType === "Percentage" &&
                                !isValidPercentage
                              )
                                return;

                              this.handleInputChange({
                                target: {
                                  name: "surchargeIfz",
                                  value,
                                },
                              });
                            } else {
                              this.handleInputChange({
                                target: {
                                  name: "surchargeIfz",
                                  value,
                                },
                              });
                            }
                          }}
                          value={this.state.searchDate.surchargeIfz}
                        />
                        <div className="input-group-append">
                          <select
                            className="form-select input-group-text"
                            value={this.state.searchDate.surchargeIfztype}
                            name="surchargeIfztype"
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            {this.state.discountTypes.map((type) => (
                              <option key={type} value={type}>
                                {type == "Percentage" ? "%" : "USD"}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )} */}

                  <div className={"col-lg-12"}>
                    <br></br>
                    <div
                      className="search-btn-col my-3"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.addContract()}
                      >
                        {t("ComplianceandBudgetScreen.Submit")}
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.cancel()}
                      >
                        {t("ComplianceandBudgetScreen.Cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  MDNewitemNav = () => {
    this.props.dispatch({ type: "MD Library", data: false });
    this.props.history.push("/Home/MDNewItem");
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    materialDeclarationslist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    showContractDetailsPane:
      state.SidePanReducer.ShowContractDetailsPane || false,
    //BY BALU MOORTHI
    contractCount: state.ContractMgmtReducer.ContractCount || {
      ClientId: 0,
      totalContracts: 0,
      overDue: 0,
      dueIn30Days: 0,
    },
    // contractDetail: state.ContractMgmtReducer.ContractDetail || {},
    contractSearchResult: state.ContractMgmtReducer.ContractSearchResult || [],
    contractShipList: state.ContractMgmtReducer.ContractShipList || [],
    contractClientName: state.ContractMgmtReducer.ContractClientName || [],
    shipNameList: state.UserManagerReducer.shipNameList || [],
    ClientIMONO: state.ContractMgmtReducer.ClientIMONO,
    contractAttachment: state.ContractMgmtReducer.contractAttachment,
    ContractType: state.ContractMgmtReducer.ContractType,
    PlanType: state.ContractMgmtReducer.PlanType,
    BillingType: state.ContractMgmtReducer.BillingType,
    contractStatus: state.ContractMgmtReducer.contractStatus,
    shipListData: state.ContractMgmtReducer.shipListData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(AddContract)
);
